import { ReactElement } from "react";
import styled from "styled-components";

interface SpacerData {
  size?: "small" | "medium" | "large";
}

// Purely structural breathing room — the flow's own gap (14px) already separates
// blocks, so these are ADDITIONAL heights that read as deliberate section breaks.
const HEIGHTS: Record<NonNullable<SpacerData["size"]>, number> = {
  small: 12,
  medium: 32,
  large: 64,
};

const Space = styled.div<{ $height: number }>`
  height: ${({ $height }) => $height}px;
`;

const SpacerBlock = ({ data }: { data: SpacerData }): ReactElement => (
  <Space aria-hidden="true" $height={HEIGHTS[data.size ?? "medium"] ?? HEIGHTS.medium} />
);

export default SpacerBlock;
